import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuIcon from '@mui/icons-material/Menu'; // Menu button for mobile
import { logoutRequest } from '../redux/actions/authActions';
import './Sidebar.css';
import { getMenuItemsByUserType } from './SidebarmenuItems';
import { setViewMode } from '../redux/actions/actions';
import { LogoutOutlined } from '@mui/icons-material';


const Sidebar = ({ isHidden, toggleSidebar, sx }) => {

  const hasInitializedMenuItems = useRef(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const BASE_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const partnerCustomer = useSelector((state) => state.partner.partnerCustomer);
  const permissions = useSelector((state) => state.auth.userDetails?.permissions);
  const firstName = useSelector((state) => state.auth.userDetails?.first_name || '');
  const lastName = useSelector((state) => state.auth.userDetails?.last_name || '');
  const designation = useSelector((state) => state?.auth?.userDetails?.designation == "null" ? '' : state.auth.userDetails.designation);
  const profileImage = useSelector((state) => state?.auth?.userDetails?.profile_image_url == "null" ? '' : state.auth.userDetails.profile_image_url);
  const refresh = useSelector((state) => state.auth.refreshToken);
  const access = useSelector((state) => state.auth.accessToken);
  const userType = useSelector((state) => state.auth.userDetails?.user_type);
  const userPermissions = useSelector((state) => state.auth.userDetails?.userPermissions);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [expandedTopLevelId, setExpandedTopLevelId] = useState(null);
  const [expandedChildMap, setExpandedChildMap] = useState({});
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    if (permissions !== null) {
      const menu = getMenuItemsByUserType(userType, permissions, partnerCustomer, userPermissions);
      setMenuItems(menu);

    }
    setSelectedItemId(null)
    if (currentPath === "/dashboard") {
      setExpandedTopLevelId(menuItems[1]?.id);
    } else if (currentPath === "/partner-dashboard") {
      setExpandedTopLevelId(menuItems[0]?.id);
    }
  }, [userType, partnerCustomer]);
  const updateMenu = () => {
    if (permissions === null) return
  }


  useEffect(() => {
    updateMenu();
  }, [permissions])

  useEffect(() => {
    // run only on inital render when menuitems are initialized
    if (!hasInitializedMenuItems.current && menuItems.length > 0) {
      if (
        menuItems[0].visibility &&
        menuItems[0].children?.some(child => child.visibility)
      ) {
        setExpandedTopLevelId(menuItems[0].id);
      }
      hasInitializedMenuItems.current = true;
    }
  }, [menuItems]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {

    handleMenuClose();
    // Dispatch the logout action
    // persistor.purge(); 
    dispatch(logoutRequest({ refresh, access }));

  };
  const handleProfileClick = () => {
    if (userType === 2 || userType === 3) {
      dispatch(setViewMode("partner-view"))
    }
    navigate('/profile')
  }
  const handleMenuClick = (item, level, parentId = null) => {

    const hasVisibleChildren = item.children?.some(child => child.visibility);
    const isSelected = isItemOrChildSelected(item, selectedItemId, currentPath);

    if (!hasVisibleChildren && isSelected) {
      return;
    }
    localStorage.setItem("viewMode", item.type)
    dispatch(setViewMode(item.type))
    if (hasVisibleChildren) {
      if (level === 0) {
        // Top-level item: Only one open at a time
        setExpandedTopLevelId(prev => (prev === item.id ? null : item.id));
      } else {
        // Nested: Only one expanded under each parent
        setExpandedChildMap(prev => ({
          ...prev,
          [parentId]: prev[parentId] === item.id ? null : item.id
        }));
      }
    } else {

      navigate(item.path, {
        state: { sidebarContextId: item.id }
      });
    }
  };

  // const isItemOrChildSelected = (item, selectedId, currentPath) => {
  //   const isInboxLikePath = currentPath.startsWith('/inbox');
  //   if (!item.children && item.path === currentPath) {
  //     return true;
  //   }

  //   if (
  //     !item.children &&
  //     item.path &&
  //     currentPath.startsWith(item.path)
  //   ) {
  //     return true;
  //   }
  //   if (item.children) {
  //     return item.children.some(child =>
  //       isItemOrChildSelected(child, selectedId, currentPath)
  //     );
  //   }

  //   return false;
  // };

  const isItemOrChildSelected = (item, selectedId, currentPath) => {
    const STARTS_WITH_PATHS = ['/inbox', '/event-pro', '/connections', '/report-history'];
    if (item.children) {
      return item.children.some(child =>
        isItemOrChildSelected(child, selectedId, currentPath)
      );
    }

    if (!item.path) return false;

    return STARTS_WITH_PATHS.some(p => currentPath.startsWith(p))
      ? currentPath.startsWith(item.path)
      : item.path === currentPath;
  };


  const renderMenuItem = (item, level = 0, parentId = null) => {
    const hasVisibleChildren = item.children?.some(child => child.visibility);
    const isExpanded =
      level === 0
        ? expandedTopLevelId === item.id
        : expandedChildMap[parentId] === item.id;

    const isSelected = isItemOrChildSelected(item, selectedItemId, currentPath);

    return (
      <React.Fragment key={item.id}>
        <ListItem
          button
          onClick={() => handleMenuClick(item, level, parentId)}
          sx={{ pl: 2 + level * 2 }}
        >
          <ListItemIcon sx={{ color: isSelected ? '#232323' : '#6B6B6B', }}>{item.icon}</ListItemIcon>
          <ListItemText
            primary={item.text}
            sx={{
              fontFamily: 'Inter',
              fontSize: '18.97px',
              lineHeight: '22.96px',
              letterSpacing: '0.01em',
              textAlign: 'left',
              textUnderlinePosition: 'from-font',
              textDecorationSkipInk: 'none',
              color: isSelected ? '#232323' : '#6B6B6B',
              "& .MuiTypography-root": {
                fontWeight: isSelected ? 700 : 400,
              },
            }}
          />
          {hasVisibleChildren &&
            (isExpanded ? (
              <ExpandLess sx={{ color: '#232323' }} />
            ) : (
              <ExpandMore sx={{ color: '#6B6B6B' }} />
            ))}
        </ListItem>

        {hasVisibleChildren && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.children
                .filter(child => child.visibility)
                .map(child =>
                  renderMenuItem(child, level + 1, item.id)
                )}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      {/* Toggle Button - Outside Drawer */}
      <IconButton
        onClick={toggleSidebar}
        sx={{
          position: 'fixed',
          top: '72px',
          left: isHidden ? '0px' : '273px',
          backgroundColor: '#F5F9FF',
          color: '#7398C7',
          borderRadius: '0 8px 8px 0',
          padding: '2px',
          border: '1px solid #ECEEF6',
          borderLeft: 'none',
          transition: 'left 0.3s ease',
          '&:hover': {
            backgroundColor: '#E8F0FF',
          },
          zIndex: 1000,
          minWidth: '30px',
          height: '40px',
        }}
      >
        <MenuIcon fontSize="medium" />
      </IconButton>

      <Drawer
        variant="permanent"
        sx={{
          width: isHidden ? 0 : 273,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 273,
            boxSizing: 'border-box',
            backgroundColor: '#F5F9FF',
            borderRight: '1px solid #E8E8E8',
            position: 'fixed',
            top: 73,
            bottom: 0,
            left: 0,
            transform: isHidden ? 'translateX(-273px)' : 'translateX(0)',
            transition: 'transform 0.3s ease',
            zIndex: 1000,
            overflowX: 'hidden',
          },
        }}
      >
        <Box sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}>
          {/* Profile Section */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
          }}>
            <Avatar
              sx={{ mr: 2, fontSize: '0.875rem', width: 40, height: 40 }}
              src={profileImage && profileImage !== "null" && profileImage !== "undefined" ? `${BASE_URL}${profileImage}` : undefined}
            >
              {(!profileImage || profileImage === 'null' || profileImage === 'undefined') &&
                `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`}
            </Avatar>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography
                variant="h6"
                sx={{
                  color: '#000000',
                  fontSize: '18px',
                  fontWeight: 700,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {firstName} {lastName}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#A4A4A4',
                  fontSize: '13px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {designation}
              </Typography>
            </Box>
            <IconButton
              onClick={(event) => setAnchorEl(event.currentTarget)}
              sx={{ padding: '4px' }}
            >
              <MoreHorizIcon />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {userPermissions?.includes('user-detail-read') && <MenuItem onClick={handleProfileClick}>Profile</MenuItem>}
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>

          {/* Menu Items */}
          <Box sx={{ height: "100%", overflowY: "auto" }}>
            <List sx={{ overflowY: "auto", pb: 0 }}>
              {menuItems.filter(item => item.visibility).map((item, index) =>
                renderMenuItem(item, 0)
              )}
            </List>
            <List sx={{ overflowY: "auto", pt: 0, height: "28%" }}>
              <ListItem
                button
                onClick={handleLogout}
                sx={{ pl: 2, cursor: "pointer" }}
              >
                <ListItemIcon sx={{ color: '#6B6B6B', }}><LogoutOutlined /></ListItemIcon>
                <ListItemText
                  primary="Logout"
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '18.97px',
                    lineHeight: '22.96px',
                    letterSpacing: '0.01em',
                    textAlign: 'left',
                    textUnderlinePosition: 'from-font',
                    textDecorationSkipInk: 'none',
                    color: '#6B6B6B',
                    "& .MuiTypography-root": {
                      fontWeight: 400,
                    },
                  }}
                />
              </ListItem>
            </List>
          </Box>
        </Box>
      </Drawer>
    </>

  );
};


export default Sidebar;